import { useParams } from 'react-router-dom'
import { useAuthContext } from '@/context-state/AuthContext.jsx'

// Get the relevant account based on the URL ':spaceId'
export const useCurrentSpace = () => {
    const { spaceId } = useParams()
    const { spaces, user } = useAuthContext()

    const currentSpace = spaces.find(space => space._id === spaceId)

    return { space: currentSpace }
}